import { isApigeeReady } from './commonConstants';
import { ENV_CONSTANT } from './enums';

const getBaseURI = () => {
  switch (window._env_.REACT_APP_ENV) {
    case ENV_CONSTANT.LOCAL:
      return isApigeeReady
        ? `https://api-dev.apip.awsnonprod.healthcareit.net/pipp`
        : `https://webportal.prepay.awsnonprod.healthcareit.net`;
    case ENV_CONSTANT.DEVELOP:
      return isApigeeReady
        ? `https://api-dev.apip.awsnonprod.healthcareit.net/pipp`
        : `https://webportal.prepay.awsnonprod.healthcareit.net`;
    case ENV_CONSTANT.UAT:
      return isApigeeReady
        ? `https://api-qa.apip.awsnonprod.healthcareit.net/pipp`
        : `https://prepayweb-cert.portal.optum.com`;
    case ENV_CONSTANT.PRODUCTION:
      return isApigeeReady
        ? `https://api.apip.awsprod.healthcareit.net/pipp`
        : `https://prepayweb.portal.optum.com`;
    default:
      return `https://webportal.prepay.awsnonprod.healthcareit.net`;
  }
};

//this is where all the apis will live.
export const baseUri = getBaseURI();

const apiExportList = {
  userConfigs: `${baseUri}/webportal/v1/userconfigs`,
  /* * * * * * * * * * * * * * * * * * * *
  PREPAY CLAIMS APIS
  * * * * * * * * * * * * * * * * * * * */
  getClaimSearchResults: `${baseUri}/webportal/v1/claims/prepay/search/id`,
  getClaimAdvancedSearchResult: `${baseUri}/webportal/v1/claims/prepay/search/advanced`,
  exportClaimsAdvancedSearch: `${baseUri}/prepaywebportal/api/v1/claims/prepay/advanced-search/export`,
  getClaimHeader: `${baseUri}/webportal/v1/claims/prepay/overview/header`,
  getClaimLines: `${baseUri}/webportal/v1/claims/prepay/overview/lines`,
  getClaimPatientMember: `${baseUri}/webportal/v1/claims/prepay/overview/patient-member`,
  getClaimProviders: `${baseUri}/webportal/v1/claims/prepay/overview/providers`,
  getClaimAttachments: `${baseUri}/webportal/v1/claims/prepay/overview/attachment-info`,
  editClaimAttachmentInfo: `${baseUri}/webportal/v1/claims/prepay/overview/attachment-info`,
  getDownloadClaimAttachment: `${baseUri}/webportal/v1/claims/prepay/overview/attachments`,
  deleteClaimAttachment: `${baseUri}/webportal/v1/claims/prepay/actions/delete-attachments`,
  getCaseSearchApiById: `${baseUri}/prepaywebportal/api/v1/claims/external/casesearch/search-by-id`,
  getAppealsForClaims: `${baseUri}/webportal/v1/claims/prepay/appeals?claimId=`,
  getClaimInvoiceActivities: `${baseUri}/webportal/v1/claims/prepay/overview/activities`,
  getClaimRoutingData: `${baseUri}/webportal/v1/claims/prepay/overview/routes`,
  getEORVersions: `${baseUri}/webportal/v1/lookup/prepay/eor-versions`,
  createPortalEOR: `${baseUri}/webportal/v1/claims/external/document/portal-eor`,
  getAdjustmentStatuses: `${baseUri}/webportal/v1/lookup/claims/adjustment-statuses`,
  getAdjustmentReasons: `${baseUri}/webportal/v1/lookup/claims/adjustment-reasons`,
  getClientNetworks: `${baseUri}/webportal/v1/lookup/claims/client-networks`,
  getClientServices: `${baseUri}/webportal/v1/lookup/claims/client-services`,
  getClientNames: `${baseUri}/prepaywebportal/api/v1/lookup/claims/client-names`,
  getClaimServices: `${baseUri}/prepaywebportal/api/v1/lookup/claims/all-services`,
  getCreateClaimLookup: `${baseUri}/prepaywebportal/api/v1/lookup/claim-entry`,
  getClaimOperations: `${baseUri}/webportal/v1/claims/prepay/overview/operations`,
  setClaimOperations: `${baseUri}/prepaywebportal/api/v1/claims/prepay/actions/claim-operations`,

  //update endpoint
  /* * * * * * * * * * * * * * * * * * * *
  CLAIM ACTION APIS
  * * * * * * * * * * * * * * * * * * * */
  adjustSavings: `${baseUri}/webportal/v1/claims/prepay/actions/save-claim`,
  attachClaimDocument: `${baseUri}/webportal/v1/claims/prepay/actions/attach-documents`,
  createClaim: `${baseUri}/webportal/v1/claims/claim-entry`,
  /* * * * * * * * * * * * * * * * * * * *
  PROVIDER API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  /* * * * * * * * * * * * * * * * * * * *
  RULES API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getRuleSpecCategories: `${baseUri}/webportal/v1/lookup/rulespec/rulespec-categories`,
  getRuleSpecAdvLookups: `${baseUri}/webportal/v1/lookup/rulespec`,
  getRuleSpecAdvancedSearchData: `${baseUri}/webportal/v1/rulespecs/search/advanced`,
  getRuleSpec: `${baseUri}/webportal/v1/rulespecs/prepay/rulespec`,
  getAllRuleSpecs: `${baseUri}/webportal/v1/rulespecs/prepay/rulespecs`,
  createRuleSpec: `${baseUri}/webportal/v1/rulespecs/prepay/create-rulespec`,
  editRuleSpec: `${baseUri}/webportal/v1/rulespecs/prepay/update-rulespec`,
  getReasonCodesResults: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/reasoncodes`,
  getReasonCodeDetail: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/reasoncode`,
  createReasonCode: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/add-reasoncode`,
  editReasonCode: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/update-reasoncode`,
  getRulesDocumentFiles: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/files/list`,
  attachRuleDocument: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/actions/attach-documents`,
  downloadRuleDocument: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/client-files/download`,
  getDocumentReferencesData: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/document-references/list`,
  addDocumentReference: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/document-references/add`,
  editDocumentReference: `${baseUri}/prepay-rulespecs/v1/api/rulespecs/document-references/update`,
  getRuleHistory: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/rulespec/history`,
  deleteRuleAttachment: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/actions/delete-attachment`,
  /* * * * * * * * * * * * * * * * * * * *
  APPEALS API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getAppealsSearchGrid: `${baseUri}/webportal/v1/appeals/search/id/`,
  getExactAppealsSearchGrid: `${baseUri}/webportal/v1/appeals/search-by-appeal-id/`,
  getAppealsHeaderData: `${baseUri}/webportal/v1/appeals/overview/header?appealId=`,
  getAppealNotesData: `${baseUri}/webportal/v1/appeals/overview/notes`,
  getAppealAdvancedSearchLookup: `${baseUri}/webportal/v1/lookup/appeals/advanced-search`,
  getAppealAdvancedSearch: `${baseUri}/webportal/v1/appeals/search/advanced`,
  getAppealAttachmentInfo: `${baseUri}/webportal/v1/appeals/attachment-info`,
  getAppealsDownloadAttachment: `${baseUri}/webportal/v1/appeals/attachments`,
  getAppealsCreateLookup: `${baseUri}/webportal/v1/lookup/appeals/create?appealTypeFlagId=`,
  getAppealDocumentType: `${baseUri}/webportal/v1/appeals/attachments/document-types`,
  getAppealsReconsiderationDropdowns: `${baseUri}/prepaywebportal/api/v1/lookup/appeals/reconsideration`,
  deleteAppealNote: `${baseUri}/webportal/v1/appeals/notes/delete`,
  getAppealStatus: `${baseUri}/webportal/v1/appeals/overview/appeal-statuses/all`,
  getAppealStatusCount: `${baseUri}/webportal/v1/appeals/appeals/search/all-counts`,
  exportAppealsAdvancedSearch: `${baseUri}/webportal/v1/appeals/advanced-search/export`,
  getAssigneeList: `${baseUri}/webportal/v1/users`,
  updateAssigneeUser: `${baseUri}/webportal/v1/users`,
  addAssigneeUser: `${baseUri}/webportal/v1/users`,
  getClientsByStatus: `${baseUri}/webportal/v1/appeals/search/clients-by-status`,

  /* * * * * * * * * * * * * * * * * * * *
  APPEALS ACTION APIS
  * * * * * * * * * * * * * * * * * * * */
  addANote: `${baseUri}/webportal/v1/appeals/notes/add/`,
  createAppeal: `${baseUri}/webportal/v1/appeals/create`,
  editAppealHeader: `${baseUri}/webportal/v1/appeals/overview/header`,
  editAppealStatus: `${baseUri}/api/v1/appeals/batch/onhold`,
  attachAppealsDocument: `${baseUri}/webportal/v1/appeals/actions/attach-documents`,
  deleteAttachAppealDocument: `${baseUri}/prepaywebportal/api/v1/appeals/attachments/delete`,
  getAppealQueue: `${baseUri}/webportal/v1/appeals/search/status/`,
  getAppealCountByType: `${baseUri}/webportal/v1/appeals/search/search/count/`,
  appealRollback: `${baseUri}/prepaywebportal/api/v1/appeals/rollback`,
  /* * * * * * * * * * * * * * * * * * * *
  CLAIM ANALYZED API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getCodeEditDetails: `${baseUri}/webportal/v1/claims/prepay/overview/code-edit-details`,
  /* * * * * * * * * * * * * * * * * * * *
  RECONSIDERATION API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getReconsiderationsData: `${baseUri}/webportal/v1/appeals/overview/reconsideration?appealId=`,
  updateReconsiderationsData: `${baseUri}/prepaywebportal/api/v1/appeals/appeal-reconsideration/save-appeal-line-response`,
  /* * * * * * * * * * * * * * * * * * * *
  Inquiry API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getInquirySearchData: `${baseUri}/webportal/v1/inquiries/search/id/`,
  getInquiryByClaimID: `${baseUri}/webportal/v1/inquiries/summary?claimId=`,
  getInquiryHeader: `${baseUri}/webportal/v1/inquiries/overview/header`,
  getInquiryAdvancedSearchLookup: `${baseUri}/prepay-inquiry/api/v1/lookup/advanced-search`,
  getInquiryMessages: `${baseUri}/webportal/v1/inquiries/overview/messages`,
  getInquiryAdvancedSearch: `${baseUri}/webportal/v1/inquiries/search/advanced`,
  getInquiryAttachmentInfo: `${baseUri}/webportal/v1/inquiries/attachment-info`,
  getDownloadInquiryAttachment: `${baseUri}/webportal/v1/inquiries/attachments`,
  attachInquiryDocument: `${baseUri}/webportal/v1/inquiries/actions/attach-documents`,
  deleteInquiryDocument: `${baseUri}/prepay-inquiry/api/v1/delete-attachment`,
  getInquiryCreateLookup: `${baseUri}/webportal/v1/inquiries/lookup/create`,
  createInquiry: `${baseUri}/webportal/v1/inquiries/create`,
  updateInquiry: `${baseUri}/webportal/v1/inquiries/update`,
  closeInquiry: `${baseUri}/webportal/v1/inquiries/actions/close`,
  getInquiryCategory: `${baseUri}/webportal/v1/inquiries/get-inquiry-category`,
  /* * * * * * * * * * * * * * * * * * * *
  Document API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getDocumentDirectories: `${baseUri}/webportal/v1/documents/directories/list`,
  getDocumentArchiveDirectories: `${baseUri}/webportal/v1/documents/directories/archive/list`,
  getDocumentFiles: `${baseUri}/webportal/v1/documents/files/list`,
  getDownloadDocument: `${baseUri}/webportal/v1/documents/files/download`,
  deleteDocuments: `${baseUri}/webportal/v1/documents/files/delete`,
  uploadDocument: `${baseUri}/webportal/v1/documents/upload`,
  getDocumentsDownloadZip: `${baseUri}/prepaywebportal/api/v1/documents/files/downloads`,
  /* * * * * * * * * * * * * * * * * * * *
  Invoicing API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getInvoicingDirectories: `${baseUri}/webportal/v1/invoices/client-folders`,
  // getInvoicingFilesList: `${baseUri}/webportal/v1/invoices/client-files`,
  getInvoicingFilesList: `${baseUri}/prepay-invoice/api/v1/invoicing/client-files`,
  getDownloadInvoice: `${baseUri}/webportal/v1/invoices/client-files/download`,
  getClientTypeInvoiceList: `${baseUri}/prepay-invoice/api/v1/clientmanagement/clientpartner/list-by-type`,
  createInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/toqueue`,
  getInvoiceSearchList: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/search`,
  getSearchInvoiceDownload: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/download`,
  uploadInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/upload`,
  deleteInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/archive`,
  renameInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/rename`,
  outgoingInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/outgoing`,
  /* * * * * * * * * * * * * * * * * * * *
  Client Management API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getClientsData: `${baseUri}/webportal/v1/clientmanagement/clientpartner/list`,
  getClientDetail: `${baseUri}/webportal/v1/clientmanagement/clientpartner/search`,
  getClientFeeSchedule: `${baseUri}/webportal/v1/clientmanagement/clientpartner/fee-schedule/list`,
  getAllClientServices: `${baseUri}/prepaywebportal/api/v1/lookup/clientmanagement`,
  addFeeSchedule: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/fee-schedule`,
  getClientFeatureList: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/feature/list`,
  updateClientFeature: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/feature/update`,
  getClientDetails: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/details`,

  /* * * * * * * * * * * * * * * * * * * *
  Appeal Responses API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  getAppealResponsesData: `${baseUri}/prepaywebportal/api/v1/appeals/responses/all`,
  editAppealResponse: `${baseUri}/prepaywebportal/api/v1/appeals/appeal-response/update`,
  addAppealResponse: `${baseUri}/prepaywebportal/api/v1/appeals/responses/add`,
  /* * * * * * * * * * * * * * * * * * * *
  Activity Log API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  activityLogs: `${baseUri}/prepay-activitylog/api/v1/activitylogs`,

  /* * * * * * * * * * * * * * * * * * * *
  My Recent Activities API CONSTANTS
  * * * * * * * * * * * * * * * * * * * */
  myRecentActivities: `${baseUri}/prepay-activitylog/api/v1/myactivitylogs`,
};

if (!isApigeeReady) {
  let replaceApiExportList = {
    userConfigs: `${baseUri}/prepaywebportal/api/v1/userconfigs`,
    /* * * * * * * * * * * * * * * * * * * *
    PREPAY CLAIMS APIS
    * * * * * * * * * * * * * * * * * * * */
    getClaimSearchResults: `${baseUri}/prepaywebportal/api/v1/claims/prepay/search/id`,
    getClaimAdvancedSearchResult: `${baseUri}/prepaywebportal/api/v1/claims/prepay/search/advanced`,
    exportClaimsAdvancedSearch: `${baseUri}/prepaywebportal/api/v1/claims/prepay/advanced-search/export`,
    getClaimHeader: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/header`,
    getClaimLines: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/lines`,
    getClaimPatientMember: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/patient-member`,
    getClaimProviders: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/providers`,
    getClaimAttachments: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/attachment-info`,
    editClaimAttachmentInfo: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/attachment-info`,
    getDownloadClaimAttachment: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/attachments`,
    deleteClaimAttachment: `${baseUri}/prepaywebportal/api/v1/claims/prepay/actions/delete-attachments`,
    getCaseSearchApiById: `${baseUri}/prepaywebportal/api/v1/claims/external/casesearch/search-by-id`,
    getAppealsForClaims: `${baseUri}/prepaywebportal/api/v1/claims/prepay/appeals?claimId=`,
    getClaimInvoiceActivities: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/activities`,
    getClaimRoutingData: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/routes`,
    getEORVersions: `${baseUri}/prepaywebportal/api/v1/lookup/prepay/eor-versions`,
    createPortalEOR: `${baseUri}/prepaywebportal/api/v1/claims/external/document/portal-eor`,
    getAdjustmentStatuses: `${baseUri}/prepaywebportal/api/v1/lookup/claims/adjustment-statuses`,
    getAdjustmentReasons: `${baseUri}/prepaywebportal/api/v1/lookup/claims/adjustment-reasons`,
    getClientNetworks: `${baseUri}/prepaywebportal/api/v1/lookup/claims/client-networks`,
    getClientServices: `${baseUri}/prepaywebportal/api/v1/lookup/claims/client-services`,
    getCreateClaimLookup: `${baseUri}/prepaywebportal/api/v1/lookup/claim-entry`,
    getClaimOperations: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/operations`,
    setClaimOperations: `${baseUri}/prepaywebportal/api/v1/claims/prepay/actions/claim-operations`,
    /* * * * * * * * * * * * * * * * * * * *
    CLAIM ACTION APIS
    * * * * * * * * * * * * * * * * * * * */
    adjustSavings: `${baseUri}/prepaywebportal/api/v1/claims/prepay/actions/save-claim`,
    attachClaimDocument: `${baseUri}/prepaywebportal/api/v1/claims/prepay/actions/attach-documents`,
    createClaim: `${baseUri}/prepaywebportal/api/v1/claims/claim-entry`,
    /* * * * * * * * * * * * * * * * * * * *
    PROVIDER API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    /* * * * * * * * * * * * * * * * * * * *
    RULE_API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getRuleSpecCategories: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/lookup/rulespec-categories`,
    getRuleSpecAdvLookups: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/lookup/rulespec`,
    getRuleSpecAdvancedSearchData: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/search/advanced`,
    getAllRuleSpecs: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/rulespecs`,
    getRuleSpec: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/rulespec`,
    createRuleSpec: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/create-rulespec`,
    editRuleSpec: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/update-rulespec`,
    getReasonCodesResults: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/reasoncodes`,
    createReasonCode: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/add-reasoncode`,
    editReasonCode: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/update-reasoncode`,
    getRulesDocumentFiles: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/files/list`,
    attachRuleDocument: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/actions/attach-documents`,
    downloadRuleDocument: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/client-files/download`,
    getDocumentReferencesData: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/document-references/list`,
    addDocumentReference: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/document-references/add`,
    editDocumentReference: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/document-references/update`,
    getRuleHistory: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/prepay/rulespec/history`,
    deleteRuleAttachment: `${baseUri}/prepay-rulespecs/api/v1/rulespecs/actions/delete-attachment`,
    /* * * * * * * * * * * * * * * * * * * *
    APPEALS API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getAppealsSearchGrid: `${baseUri}/prepaywebportal/api/v1/appeals/search/id/`,
    getExactAppealsSearchGrid: `${baseUri}/prepaywebportal/api/v1/appeals/search-by-appeal-id/`,
    exportAppealsAdvancedSearch: `${baseUri}/prepaywebportal/api/v1/appeals/advanced-search/export`,
    getAppealsHeaderData: `${baseUri}/prepaywebportal/api/v1/appeals/overview/header?appealId=`,
    getAppealNotesData: `${baseUri}/prepaywebportal/api/v1/appeals/overview/notes`,
    getAppealAdvancedSearchLookup: `${baseUri}/prepaywebportal/api/v1/lookup/appeals/advanced-search`,
    getAppealAdvancedSearch: `${baseUri}/prepaywebportal/api/v1/appeals/search/advanced`,
    getAppealAttachmentInfo: `${baseUri}/prepaywebportal/api/v1/appeals/attachment-info`,
    getAppealsDownloadAttachment: `${baseUri}/prepaywebportal/api/v1/appeals/attachments`,
    getAppealsCreateLookup: `${baseUri}/prepaywebportal/api/v1/lookup/appeals/create?appealTypeFlagId=`,
    getAppealDocumentType: `${baseUri}/prepaywebportal/api/v1/appeals/attachments/document-types`,
    deleteAppealNote: `${baseUri}/prepaywebportal/api/v1/appeals/notes/delete`,
    getAppealStatus: `${baseUri}/prepaywebportal/api/v1/appeals/overview/appeal-statuses/all`,
    getAppealStatusCount: `${baseUri}/prepaywebportal/api/v1/appeals/search/all-counts`,
    getAssigneeList: `${baseUri}/prepaywebportal/api/v1/users`,
    updateAssigneeUser: `${baseUri}/prepaywebportal/api/v1/users`,
    addAssigneeUser: `${baseUri}/prepaywebportal/api/v1/users`,
    getClientsByStatus: `${baseUri}/prepaywebportal/api/v1/appeals/search/clients-by-status`,
    /* * * * * * * * * * * * * * * * * * * *
    APPEALS ACTION APIS
    * * * * * * * * * * * * * * * * * * * */
    addANote: `${baseUri}/prepaywebportal/api/v1/appeals/notes/add/`,
    createAppeal: `${baseUri}/prepaywebportal/api/v1/appeals/create`,
    editAppealHeader: `${baseUri}/prepaywebportal/api/v1/appeals/overview/header`,
    editAppealStatus: `${baseUri}/prepaywebportal/api/v1/appeals/batch/onhold`,
    attachAppealsDocument: `${baseUri}/prepaywebportal/api/v1/appeals/actions/attach-documents`,
    getAppealQueue: `${baseUri}/prepaywebportal/api/v1/appeals/search/status/`,
    getAppealCountByType: `${baseUri}/prepaywebportal/api/v1/appeals/search/count/`,
    appealRollback: `${baseUri}/prepaywebportal/api/v1/appeals/rollback`,
    /* * * * * * * * * * * * * * * * * * * *
    CLAIM ANALYZED API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getCodeEditDetails: `${baseUri}/prepaywebportal/api/v1/claims/prepay/overview/code-edit-details`,
    /* * * * * * * * * * * * * * * * * * * *
    RECONSIDERATION API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getReconsiderationsData: `${baseUri}/prepaywebportal/api/v1/appeals/overview/reconsideration?appealId=`,
    /* * * * * * * * * * * * * * * * * * * *
    Inquiry API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getInquirySearchData: `${baseUri}/prepay-inquiry/api/v1/search/id/`,
    getInquiryByClaimID: `${baseUri}/prepay-inquiry/api/v1/summary?claimId=`,
    getInquiryHeader: `${baseUri}/prepay-inquiry/api/v1/overview/header`,
    getInquiryAdvancedSearchLookup: `${baseUri}/prepay-inquiry/api/v1/lookup/advanced-search`,
    getInquiryMessages: `${baseUri}/prepay-inquiry/api/v1/overview/messages`,
    getInquiryAdvancedSearch: `${baseUri}/prepay-inquiry/api/v1/search/advanced`,
    getInquiryAttachmentInfo: `${baseUri}/prepay-inquiry/api/v1/attachment-info`,
    getDownloadInquiryAttachment: `${baseUri}/prepay-inquiry/api/v1/attachments`,
    attachInquiryDocument: `${baseUri}/prepay-inquiry/api/v1/actions/attach-documents`,
    deleteInquiryDocument: `${baseUri}/prepay-inquiry/api/v1/delete-attachment`,
    getInquiryCreateLookup: `${baseUri}/prepay-inquiry/api/v1/lookup/create`,
    createInquiry: `${baseUri}/prepay-inquiry/api/v1/create`,
    updateInquiry: `${baseUri}/prepay-inquiry/api/v1/update`,
    closeInquiry: `${baseUri}/prepay-inquiry/api/v1/actions/close`,
    getInquiryCategory: `${baseUri}/prepay-inquiry/api/v1/lookup/get-inquiry-category`,
    /* * * * * * * * * * * * * * * * * * * *
    Document API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getDocumentDirectories: `${baseUri}/prepaywebportal/api/v1/documents/directories/list`,
    getDocumentArchiveDirectories: `${baseUri}/prepaywebportal/api/v1/documents/directories/archive/list`,
    getDocumentFiles: `${baseUri}/prepaywebportal/api/v1/documents/files/list`,
    getDownloadDocument: `${baseUri}/prepaywebportal/api/v1/documents/files/download`,
    deleteDocuments: `${baseUri}/prepaywebportal/api/v1/documents/files/delete`,
    uploadDocument: `${baseUri}/prepaywebportal/api/v1/documents/upload`,
    getDocumentsDownloadZip: `${baseUri}/prepaywebportal/api/v1/documents/files/downloads`,
    /* * * * * * * * * * * * * * * * * * * *
    Invoicing API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getInvoicingDirectories: `${baseUri}/prepaywebportal/api/v1/invoices/client-folders`,
    // getInvoicingFilesList: `${baseUri}/prepaywebportal/api/v1/invoices/client-files`,
    getInvoicingFilesList: `${baseUri}/prepay-invoice/api/v1/invoicing/client-files`,
    getDownloadInvoice: `${baseUri}/prepaywebportal/api/v1/invoices/client-files/download`,
    getClientTypeInvoiceList: `${baseUri}/prepay-invoice/api/v1/clientmanagement/clientpartner/list-by-type`,
    createInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/toqueue`,
    getInvoiceSearchList: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/search`,
    getSearchInvoiceDownload: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/download`,
    uploadInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/upload`,
    deleteInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/archive`,
    renameInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/rename`,
    outgoingInvoice: `${baseUri}/prepay-invoice/api/v1/invoicing/invoice/file/outgoing`,
    /* * * * * * * * * * * * * * * * * * * *
    Client Management API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getClientsData: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/list`,
    getClientDetail: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/search`,
    getClientFeeSchedule: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/fee-schedule/list`,
    getAllClientServices: `${baseUri}/prepaywebportal/api/v1/lookup/clientmanagement`,
    addFeeSchedule: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/fee-schedule`,
    getClientFeatureList: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/feature/list`,
    updateClientFeature: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/feature/update`,
    getClientDetails: `${baseUri}/prepaywebportal/api/v1/clientmanagement/clientpartner/details`,

    /* * * * * * * * * * * * * * * * * * * *
    Appeal Responses API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    getAppealResponsesData: `${baseUri}/prepaywebportal/api/v1/appeals/responses/all`,
    editAppealResponse: `${baseUri}/prepaywebportal/api/v1/appeals/appeal-response/update`,
    addAppealResponse: `${baseUri}/prepaywebportal/api/v1/appeals/responses/add`,
    /* * * * * * * * * * * * * * * * * * * *
    Activity Log API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    activityLogs: `${baseUri}/prepay-activitylog/api/v1/activitylogs`,

    /* * * * * * * * * * * * * * * * * * * *
    My Recent Activities API CONSTANTS
    * * * * * * * * * * * * * * * * * * * */
    myRecentActivities: `${baseUri}/prepay-activitylog/api/v1/myactivitylogs`,
  };
  Object.assign(apiExportList, replaceApiExportList);
}

export default apiExportList;
